// extracted by mini-css-extract-plugin
export default {"confirm-body":"confirmationpopup_confirm-body__9Ww3w"};